import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import NavbarIconsGroupConcern from "../generic-nav-bar/NavbarIconsGroupConcern";
import { cleanCatalogConcernByGroupVision } from "../../app/actions/catalogActions";
import { startLoadingTopicQuestionLists } from "../../app/actions/catalogTopicQuestionActions";
import CheckListConcernComponent from "./CheckListConcernComponent";
import ListGroupComponent from "./ListGroupComponent";

const AdminGroupConcernScreen = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const [groupVisionSelected, setGroupVisionSelected] = useState("");

  useEffect(() => {
    dispatch(startLoadingTopicQuestionLists());
    dispatch(cleanCatalogConcernByGroupVision());
  }, []);


  return (
    <div>
      <NavbarIconsGroupConcern />
      <div className="d-flex justify-content-center page-title">{t("admin.group_concerns.register")}</div>

      {/*<hr className="line-hr" />*/}

      <div className="section is-fullheight">
        <div className="container">
          <form noValidate>
            <div className="row">
              <div className="col-md-4">
                <label className="form-label" style={{ fontWeight: "bold" }}>
                  {t("admin.group_concerns.group_list")}
                </label>

                <ListGroupComponent groupVisionSelected={groupVisionSelected} setGroupVisionSelected={setGroupVisionSelected}/>
              </div>
              <div className="col-md-8">
                <label className="form-label" style={{ fontWeight: "bold" }}>
                  {t("admin.group_concerns.concern_list")}
                </label>
                <div className="control">
                 <CheckListConcernComponent 
                    groupSelected={groupVisionSelected} 
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminGroupConcernScreen;
